<template>
  <dialogComp :zIndex="9990" ref="dialog">
    <div class="clause-content-box">
      <div id="ruleBox" class="clause-content">
        <div class="textArea">
          <p class="tit">#领克06 SHERO 粉色奇遇季#</p>
          <textarea
            placeholder="点击输入话题"
            name=""
            id=""
            cols="30"
            rows="10"
            v-model="shareTxt"
          ></textarea>
          <p class="des">上传至少一张照片或一段视频文字至少50字以上</p>
        </div>
        <div class="uploadBox">
          <div class="chooseBtn">
            <img
              src="https://picbed.qunarzz.com/0192852338302085f53e4776beaa8c22.png"
              alt=""
            />
            <input @change="changeFile" class="file" type="file" />
          </div>
          <div class="upload">
            <div
              class="upload-i"
              v-for="(item, index) in uploadList"
              :key="index"
            >
              <img
                v-if="item.type != 'video'"
                :src="item.src"
                alt=""
              />
              <video controls v-else :src="item.src" preload="auto"></video>
            </div>
          </div>
        </div>
      </div>
    </div>
    <img
      @click="submit"
      src="https://picbed.qunarzz.com/374e9252c57819ec41b13b2afbec77d9.png"
      class="uploadBtn"
      alt=""
    />
  </dialogComp>
</template>
<script>
import dialogComp from "@/components/dialog/index.vue";
import { Button } from "mint-ui";
import loginDialog from "../login/index";
import giftDialog from "../gift/index";
export default {
  components: {
    dialogComp,
    "mt-button": Button,
  },
  data() {
    return {
      text: "",
      shareTxt: "",
      uploadList: [],
    };
  },
  mounted(){
    Indicator.open();
  },
  methods: {
    show() {
      this.$refs.dialog.show();
    },
    submit() {
      let files = [];
      let params = {};
      this.uploadList.forEach((item) => {
        if (item.src) {
          files.push(item.fileKey);
        }
      });
      params.fileKeys = files.join(",");
      params.shareTxt = this.text + this.shareTxt;
      this.$http({
        url: "/linke/shareMessage/save",
        type: "post",
        data: params,
        config: { formType: true },
        login: loginDialog,
        success: (res) => {
          giftDialog({
            type: "keepSuccess",
          });
        },
      });
    },
    close() {
      this.$refs.dialog.close();
    },
    changeFile(e) {
      let file = e.target.files[0];
      let formData = new FormData();
      let videoData = new FormData();
      formData.append("shareFile", file);
      videoData.append("videoFile", file);
      let imgSrc = window.URL.createObjectURL(file);
      this.$http({
        url:
          file.type == "video/mp4"
            ? "/linke/video/upload"
            : "/linke/pic/upload",
        type: "post",
        data: file.type == "video/mp4" ? videoData : formData,
        config: { formType: false },
        login: loginDialog,
        success: (res) => {
          this.uploadList.push({
            src: imgSrc,
            type: file.type == "video/mp4" ? "video" : "img",
            fileKey: res.data.fileKey,
          });
        },
      });
    },
  },
};
</script>

<style lang="less" scoped="true">
.rem(@name,@px) {
  @{name}: unit(@px / 37.5, rem);
}
.rule-tit {
  .rem(font-size,14);
  .rem(margin-bottom,12);
  font-weight: bold;
}
.rule-box {
  .rem(margin-bottom,12);
}
.clause-content-box {
  width: 100%;
  box-sizing: border-box;
  max-height: 271px;
  position: relative;
  background: url(https://picbed.qunarzz.com/bd23b47964733478ba8900b7f798d4c6.png)
    no-repeat;
  background-size: 100% auto;
  padding-top: 10px;
  strong {
    color: #fff;
  }
  .clause-title {
    color: #fff;
    font-size: 0.4rem;
    width: 100%;
    padding-bottom: 20px;
    display: flex;
    align-items: center;
    position: relative;
    img {
      width: 82px;
      display: block;
      margin-left: auto;
      margin-right: auto;
    }
    .rule-close {
      width: 16px;
      position: absolute;
      right: 10px;
      top: -10px;
    }
  }
  .rule-title {
    color: #fad483;
  }
  .clause-content {
    height: 260px;
    line-height: 2;
    width: calc(100% - 15px);
    margin-left: auto;
    margin-right: auto;
    overflow: auto;
    .rem(font-size,10);
    color: #fff;
  }
}
.strong {
  font-weight: bold;
}
.textArea {
  width: 100%;
  background-color: #fff;
  padding: 14px;
  box-sizing: border-box;
  p {
    color: #6e6e6e;
  }
  textarea {
    height: 75px;
    display: block;
    width: 100%;
    border: none;
  }
  .tit {
    font-size: 16px;
  }
  .des {
    text-align: right;
  }
}
.chooseBtn {
  width: 36px;
  position: relative;
}
.uploadBox {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 15px;
  margin-top: 20px;
}
.file {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  z-index: 2;
}
.upload {
  display: flex;
  align-items: center;
  width: 250px;
}
.upload-i {
  width: 76px;
  height: 43px;
  margin-left: 8px;
  display: block;
  video,
  img {
    width: 100%;
    height: 100%;
  }
}
.uploadBtn {
  margin-top: 20px;
}
</style>